var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "section",
        { staticClass: "search-region" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _vm.attachedView
                      ? _c(
                          "form",
                          {
                            ref: "filterForm",
                            attrs: { action: "#" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.filterView.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.attachedView.filter_form),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("node-element-local-tasks", { attrs: { nid: _vm.nid } }),
                  _vm._v(" "),
                  _vm.unpublished
                    ? _c("div", { staticClass: "messages warning" }, [
                        _vm._v("\n          Not published\n        "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } }),
                  _vm._v(" "),
                  _vm.attachedView
                    ? [
                        _c("website-list", {
                          attrs: { list: _vm.attachedView },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }